li.option-item {
    display: block;
}
